import React, {
	useEffect,
	useState,
	useContext,
	useCallback,
	useRef,
	Fragment as Frag
} from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import {TextBlock, /*RoundShape,*/ RectShape} from 'react-placeholder/lib/placeholders';
import InfiniteScroll from 'react-infinite-scroller';
import { Waypoint } from "react-waypoint";

import {
	makeStyles,
	Grid,
	Divider,
	Popover,
	MenuItem,
	Typography,
	RootRef,
	useTheme
} from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Fido from "../utils/Fido";
import Constants from "../utils/Constants";
import AuthorizedUser from "../utils/AuthorizedUser";
import AuthorizedUserContext from "../utils/AuthorizedUserContext";
import DeconstructActivity from '../utils/DeconstructActivity';
//import DeepMerge from "../utils/DeepMerge";
import PatternActions from "../components/PatternActions";
import ShareToBtaDialog from "../components/ShareToBtaDialog";
import PaddedLayout from "../components/PaddedLayout";
import ActivityTopics from "../components/ActivityTopics";
import PatternMomentum from "../components/PatternMomentum";
import PatternMetrics from "../components/PatternMetrics";
import PaperActivity from "../components/PaperActivity";
import ScrollableArea from "../components/ScrollableArea";
import CircularLoadingIndicator from "../components/CircularLoadingIndicator";
import PatternVerticalTimeline from "../components/PatternVerticalTimeline";
import ReactPlaceholder from 'react-placeholder';
import SharePatternForm from '../components/SharePatternForm';
import UserActivityTrail from "../components/UserActivityTrail";

const styles = makeStyles(theme => ({
	fullScreenClassName: {
		[theme.breakpoints.only('sm')]: {
			paddingTop: `${theme.spacing(28.375)}px !important`
		}
	},

	paddedLayout: {
		paddingTop: theme.spacing(1.5)
	},

	libraryTopics: {
		fontSize: "1rem"
	},

	subTitle: {
		fontSize: "1rem",
		lineHeight: "1.7rem",
		paddingTop: theme.spacing(2)
	},

	title: {
		fontSize: "1.33rem"
	},

	metricsCards: {
		paddingTop: theme.spacing(1.5),
		paddingBottom: theme.spacing(1.5)
	},

	signalsContainer: {
		marginTop: theme.spacing(3)
	},

	paperActivity: {
		marginBottom: theme.spacing(3)
	},

	scrollGrid: {
		backgroundColor: "#e9e9e9",
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(2),
		//paddingTop: theme.spacing(1)
	},

	scrollGridItem: {
		display: "block"
	},

	listEnd: {
		borderRadius: theme.spacing(0.5),
		borderTop: `${theme.spacing(2)}px solid #e9e9e9`
	},

	listEndTop: {
		borderBottomLeftRadius: 0,
		borderBottomRightRadius: 0,
	},

	listEndBottom: {
		borderTopLeftRadius: 0,
		borderTopRightRadius: 0,
	},

	newSignal: {
		// borderTop: `5px solid ${theme.palette.secondary.mustard}`
	},

	flex: {
		display: "flex"
	},

	timelineItem: {
		width: "100%",
		paddingTop: theme.spacing(2)
	},

	userActivity: {
		marginTop: theme.spacing(4)		
	}
}));

const placeholderColor = Constants.COLORS.PLACEHOLDER_BG;
const itemPlaceHolder = (
	<Grid container direction="column">
		<Grid item>
			<Grid container justify="space-between">
				<Grid item>
					<TextBlock rows={1} color={placeholderColor} style={{width: 100}} />
				</Grid>
				{/* momentum was moved */}
				{/*<Grid item>
					<Grid container alignItems="center">
						<Grid item>
							<TextBlock rows={1} color={placeholderColor} style={{width: 100}} />
						</Grid>
						<Grid item>
							<RoundShape color={placeholderColor} style={{height: 15, width: 15}} />
						</Grid>
					</Grid>
				</Grid>*/}
			</Grid>
			<Grid container
				wrap="nowrap"
				spacing={2}
				style={{marginTop: 10}}>
				<Grid item>
					<RectShape color={placeholderColor} style={{width: 102, height: 56}} />
				</Grid>
				<Grid item>
					<RectShape color={placeholderColor} style={{width: 102, height: 56}} />
				</Grid>
				<Grid item>
					<RectShape color={placeholderColor} style={{width: 102, height: 56}} />
				</Grid>
				<Grid item>
					<RectShape color={placeholderColor} style={{width: 102, height: 56}} />
				</Grid>
			</Grid>
		</Grid>
		<Grid item>
			<Grid container wrap="nowrap" style={{marginTop: 20}}>
				<Grid item>
					<RectShape color={placeholderColor} style={{width: 400, height: 400}} />
				</Grid>
				<Grid item>
					<RectShape color={placeholderColor} style={{width: 600, height: 400}} />
				</Grid>
			</Grid>
		</Grid>
	</Grid>
);

function PatternDetails(props) {
	const authenticatedUser = useContext(AuthorizedUserContext);
	const [pattern, setPattern] = useState();
	const [isLoadingPage, setIsLoadingPage] = useState(false);
	const [signalsData, setSignalsData] = useState();
	const [selectedEventIds, setSelectedEventIds] = useState([]);
	const [scrollTo, setScrollTo] = useState(0);
	const [shareOpen, setShareOpen] = useState(false);
	const [shareMenuOpen, setShareMenuOpen] = useState(false);
	const [shareToBtaOpen, setShareToBtaOpen] = useState(false);
	const [defaultRecipient, setDefaultRecipient] = useState();

	const scrollAreaRef = useRef();
	const theme = useTheme();

	let classes = styles(),
		{history, patternId, status, updateHeader, resetHeader, showSnackbar, setFullScreenClassName} = props;

	// TODO: if another hook does not make this hook get called again (re-render),
	//	there is no back button and metrics headerbar remains.
	//	figure out how to get as a 'secondary' page

	// set header / title
	useEffect(() => {
		updateHeader({
			primary: false,
			title: "Pattern Details"
		});
		setFullScreenClassName(classes.fullScreenClassName);
		return () => resetHeader();
	}, [updateHeader, resetHeader, setFullScreenClassName, classes]);

	const trackView = useCallback((data) => {
		let stanley = new Fido();
		stanley.fetch(`/patterns/${data.uuid}/view`, {
			method: "PUT"
		})
			.catch(error => {
				return showSnackbar(error.message);
			});
	}, [showSnackbar]);

	useEffect(() => {
		let fidget = new Fido();
		(async () => {
			let data = await fidget.fetch(`/patterns/${patternId}`)
				.catch(error => {
					return showSnackbar(error.message);
				});

			if (data) {
				data.libraryTopics = Object.keys(data.counts.topics).map(key => {return {name: key};});
				//console.log(data);
				setPattern(data);
				trackView(data);
			}
		})();
	}, [patternId, showSnackbar, trackView]);

	const loadSignals = useCallback((page) => {
		setIsLoadingPage(true);
		let norman = new Fido();
		(async () => {
			//let data = await norman.fetch(`/simulate/patterns/${patternId}/signals?page=${page || ++pattern.lastPage}`)
			let data = await norman.fetch(`/patterns/${patternId}/signals?page=${page || ++pattern.lastPage}`)
				.catch(error => {
					return showSnackbar(error.message);
				});

			if (data) {
				/*setPattern(prevData => {
					return DeepMerge.merge(prevData, data);
				});*/
				setSignalsData(prevData => {
					let prevSignals = prevData && prevData.signals || [];
					return {...data, ...{signals: [...prevSignals, ...data.signals]}};
				});
				setIsLoadingPage(false);
			}
		})();
	}, [patternId, pattern, showSnackbar]);

	useEffect(() => {
		loadSignals(1);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const waypointEntered = (waypointInfo) => {
		let newIds = [...selectedEventIds];
		newIds.push(waypointInfo.signalId);
		setSelectedEventIds(newIds);
	};

	const waypointExited = (waypointInfo) => {
		setSelectedEventIds(selectedEventIds.filter(id => id !== waypointInfo.signalId));
	};

	const onTimelineCardClick = (id) => {
		let topOffset = 292, // due to scroll areas position
			card = scrollAreaRef.current.querySelector(`[id='${id}']`);
		if (card) {
			setScrollTo(card.offsetTop-topOffset);
		}
	};

	const shareHandler = (e) => {
		setShareMenuOpen(e.currentTarget);
	};

	const handleShareMenuClose = () => {
		setShareMenuOpen(false);
	};

	const handleShareDialogClose = () => {
		setDefaultRecipient(null);
		setShareOpen(false);
	};

	const handleShareSubmit = (patternId, values) => {
		handleShareDialogClose();

		let poodle = new Fido();
		poodle.fetch(`/patterns/${patternId}/share`, {
			method: "PUT",
			body: JSON.stringify(values)
		}, 'Sharing...', 'Shared.')
			.then(data => {
				console.log('handleShareSubmit',data)
				// updateActivityHandler(data);
			})
			.catch(error => props.showSnackbar(error.message));
	};

	const shareToBta = (notesObj) => {
		setShareToBtaOpen(false);
		if (notesObj !== false && notesObj !== undefined) {
			let fido = new Fido();
			fido.fetch(`/patterns/${patternId}/report-to-bta`, {
				method: "POST",
				body: JSON.stringify({report: notesObj})
			}, 'Sending to Case Manager...', 'Sent to Case Manager Queue.')
				.then(data => {
					console.log('shareToBta',data)
					// if (data && data.activity && !isJsonEqual(data.activity, activity)) {
					// 	updateActivityHandler(data);
					// }
				})
				.catch(error => showSnackbar(error.message));
		}
	};

	const onShareItemClicked = (type) => {
		switch (type) {
			case Constants.PATTERN.SHARE_TYPES.EMAIL:
			case Constants.PATTERN.SHARE_TYPES.TEXT_MSG:
				setShareOpen(true);
				setDefaultRecipient(type);
				break;
			case Constants.ACTIVITY.SHARE_TYPES.REPORT_TO_BTA:
				setShareToBtaOpen(true);
				break;
			default:
				break;
		}
		handleShareMenuClose();
	};

	let actionBtns = Constants.PATTERN.ACTION_BUTTONS,
	actionsArray = [
		actionBtns.getShare({
			disabled: 0,
			handleClick: shareHandler
		})
	],

	patternActions = (
		<ReactPlaceholder type="rect" ready={patternId != null} style={{width: "100%", height: 80}}>
			<PatternActions actions={actionsArray} />
		</ReactPlaceholder>
	);

	if(pattern && pattern.status !== status) {
		return (
			<Redirect to={{
				pathname: `/patterns/${pattern.status}/${patternId}`
			}}/>
		);
	} else {
		return (
			<PaddedLayout
				isLarge
				noTopPad
				className={classes.paddedLayout}>
				{pattern ?
					<Grid container direction="column">
						<Grid item>
							<Grid
								container
								direction="row"
								alignItems="center"
								justifyContent="space-between">
								<Grid item>
									<ActivityTopics
										topics={pattern.libraryTopics}
										className={classes.libraryTopics} />
								</Grid>
								<Grid item>
									{patternActions ?
										<React.Fragment>
											{patternActions}
										</React.Fragment> : null
									}
								</Grid>
							</Grid>
							{AuthorizedUser.hasMultipleLocations(authenticatedUser) ? (
								<Typography variant="h2" noWrap className={classes.subTitle}>
									<b>{pattern.locationName}</b>
								</Typography>
							) : null}
							<Typography variant="h2" noWrap className={classes.title}>
								<b>{pattern.name}</b>{pattern.email && <span>&nbsp;&lt;{pattern.email}&gt;</span>}
							</Typography>
							<div className={classes.metricsCards}>
								<PatternMetrics data={pattern.counts} />
							</div>
						</Grid>
						<Grid item>
							<Grid container className={classes.signalsContainer}>
								<Grid item sm md lg xl className={classes.flex}>
									<Grid container
										direction="column"
										alignItems="center"
										wrap="nowrap">
										<Grid item>
											<PatternMomentum
												status={pattern.status}
												momentum={pattern.momentumChange} />
										</Grid>
										<Grid item sm={12} md={12} lg={12} xl={12}
											className={`${classes.flex} ${classes.timelineItem}`}>
											<PatternVerticalTimeline
												reverseOrder
												events={pattern && pattern.signals}
												selectedEventIds={selectedEventIds}
												elementOnClick={onTimelineCardClick}
												detectionDate={pattern && pattern.detectedAt}
												isOpenEnded={pattern.status === Constants.PATTERN.STATUSES.ACTIVE} />
										</Grid>
									</Grid>
								</Grid>
								<Grid item sm={8} md={8} lg={8} xl={8}>
									<div className={`${classes.listEnd} ${classes.listEndTop}`}></div>
									<RootRef rootRef={scrollAreaRef}>
										<ScrollableArea
											scrollTo={scrollTo}
											heightReduction={theme.spacing(3.75)}
											scrollGridClassName={classes.scrollGrid}
											scrollGridItemClassName={classes.scrollGridItem}>
											<Frag>
												<InfiniteScroll
													useWindow={false}
													initialLoad={false}
													pageStart={1}
													loadMore={loadSignals}
													// TODO disabled paging
													hasMore={signalsData && signalsData.hasMoreItems && !isLoadingPage}
													// hasMore={false}
													getScrollParent={() => scrollAreaRef.current}
													loader={null}>
													{signalsData && signalsData.signals.length ? signalsData.signals.map(signal =>
														<DeconstructActivity
															key={signal.id}
															activity={signal}
															render={deconstructedProps => {
																// so ViewPatternButton shows up
																deconstructedProps.pattern = pattern;
																return (
																	<Frag>
																		<Waypoint
																			bottomOffset={"30%"}
																			fireOnRapidScroll={false}
																			onEnter={(waypointInfo) => {
																				waypointInfo.signalId = signal.soteria_id;
																				return waypointEntered(waypointInfo);
																			}}
																			onLeave={(waypointInfo) => {
																				waypointInfo.signalId = signal.soteria_id;
																				return waypointExited(waypointInfo);
																			}} />
																		<PaperActivity
																			id={signal.id}
																			history={history}
																			{...deconstructedProps}
																			expandHeaderInfo
																			//excludeHeaderInfoSent
																			showAvatarRow={false}
																			numberOfViewableComments={3}
																			className={`${classes.paperActivity} ${signal.isNew ? classes.newSignal : ""}`}
																			viewPatternConfig={{
																				icon: false,
																				title: "View in Inbox",
																				link: `/inbox/${signal.id}`
																			}}
																			// TODO translate
																			/*handleTranslateClick={translateHandler}*/ />

																			{authenticatedUser ?
																				<React.Fragment>
																					<Popover
																						open={Boolean(shareMenuOpen)}
																						anchorEl={shareMenuOpen}
																						onClose={handleShareMenuClose}
																						anchorOrigin={{
																							vertical: 'bottom',
																							horizontal: 'center',
																						}}
																						transformOrigin={{
																							vertical: 'top',
																							horizontal: 'center',
																						}}>
																						<MenuItem onClick={() => onShareItemClicked(Constants.PATTERN.SHARE_TYPES.EMAIL)}>
																							<FontAwesomeIcon className={classes.shareMenuIcon} style={{ marginRight: '5px'}} icon={["fad", "envelope"]} title="email" />
																							<Typography>Email</Typography>
																						</MenuItem>
																						<MenuItem onClick={() => onShareItemClicked(Constants.PATTERN.SHARE_TYPES.TEXT_MSG)}>
																							<FontAwesomeIcon className={classes.shareMenuIcon} style={{ marginRight: '5px'}} icon={["fad", "comment-dots"]} title="text message" />
																							<Typography>Text Message</Typography>
																						</MenuItem>

																						{AuthorizedUser.hasBTA(authenticatedUser) ?
																							<MenuItem
																								onClick={() => onShareItemClicked(Constants.PATTERN.SHARE_TYPES.REPORT_TO_BTA)}
																								disabled={
																									deconstructedProps.auditTrail &&
																									deconstructedProps.auditTrail.findIndex(item => item.type === Constants.PATTERN.AUDIT_TRAIL.REPORT_TO_BTA.ID) > -1}>
																								<FontAwesomeIcon className={classes.shareMenuIcon} style={{ marginRight: '5px'}} icon={["fad", "folder-upload"]} title="Report to case manager" />
																								<Typography>Report to Case Manager</Typography>
																							</MenuItem> : null
																						}
																					</Popover>
																					<ShareToBtaDialog
																						open={shareToBtaOpen}
																						closeHandler={shareToBta}
																						pattern={pattern}
																						anonymize={patternId && pattern.extraHeaders && authenticatedUser.ghosting} />
																				</React.Fragment> : null
																			}
																	</Frag>
																	
																);
															}} />
													) : <span />}
												</InfiniteScroll>
												{isLoadingPage ? <CircularLoadingIndicator /> : null}
											</Frag>
										</ScrollableArea>
									</RootRef>
									<div className={`${classes.listEnd} ${classes.listEndBottom}`}></div>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					: itemPlaceHolder
				}
				{authenticatedUser ?
					<SharePatternForm
						open={shareOpen}
						patternId={patternId}
						defaultRecipient={defaultRecipient}
						handleClose={handleShareDialogClose}
						handleSubmit={(patternId, values) => handleShareSubmit(patternId, values)} /> : null
				}
				{authenticatedUser && pattern ?
					<UserActivityTrail
						category={'pattern'}
						auditTrail={pattern.auditTrail}
						className={classes.userActivity} /> : null
				}
			</PaddedLayout>
		);
	}
}

PatternDetails.propTypes = {
	history: PropTypes.object.isRequired,
	patternId: PropTypes.string.isRequired,
	updateHeader: PropTypes.func.isRequired,
	resetHeader: PropTypes.func.isRequired,
	showSnackbar: PropTypes.func.isRequired,
	setFullScreenClassName: PropTypes.func.isRequired
};

export default PatternDetails;